export default __webpack_public_path__ + "static/media/mennecy.a57d3efd.jpeg";